<!-- <div class="breadcrumb_outer">
  <p>Anomaly Logs Filters:</p>
</div> -->
<div class="Content_outer">
  <mat-toolbar class="top_headerbar">
    <!-- Right-aligned section with actions -->
    <div class="right">
      <div class="all_action_btns">
        <!-- Search field for Full Name with icon -->
        <div class="custom_search width_200">
          <span class="sprite_icon search"></span>
          <input type="text" class="form-control" placeholder="Search by Full Name" [(ngModel)]="clientName"
            (input)="searchbyname($event.target.value)" />
        </div>

        <!-- Search field for Site Name -->
        <div class="custom_search width_200">
          <input type="text" class="form-control" placeholder="Search by Site Name" [(ngModel)]="site"
            (input)="searchbySite($event.target.value)" />
        </div>

        <!-- Search field for Application Name -->
        <div class="custom_search width_200">
          <input type="text" class="form-control" placeholder="Search by Application Name" [(ngModel)]="application"
            (input)="searchbyApplication($event.target.value)" />
        </div>

        <!-- Search field for Serial Number -->
        <div class="custom_search width_200">
          <input type="text" class="form-control" placeholder="Search by Serial Number" [(ngModel)]="sNumber"
            (input)="searchbySerialNo($event.target.value)" />
        </div>
      </div>
    </div>

    <div>
      <mat-form-field>
        <div class="label">
          <mat-label></mat-label>
        </div>
        <div class="inside">
          <mat-date-range-input [rangePicker]="picker">
            <input
              matStartDate
              [formControl]="range.controls['start']"
              placeholder="Start date"
            />
            <input
              matEndDate
              [formControl]="range.controls['end']"
              placeholder="End date"
            />
          </mat-date-range-input>
        </div>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <button
        mat-raised-button
        color="primary"
        class="custom_button"
        (click)="onDateRangeChange(range.value.start, range.value.end)"
        [disabled]="!range.value.start && !range.value.end"
      >
        Apply Date Range
      </button>

      <button
        mat-raised-button
        color="warn"
        class="custom_button active_clear"
        (click)="clearFilters()"
        [disabled]="
          !(
            clientName != '' ||
            site != '' ||
            application != '' ||
            sNumber != '' ||
            macAdd != '' ||
            range.value.start != null ||
            range.value.end != null
          )
        "
      >
        Clear Filters
      </button>
    </div>
  </mat-toolbar>

  <!-- Conditionally display no results message -->
  <div class="no_result"  *ngIf="!filteredData || filteredData.length === 0">
  <p style="
        font-size: 16px;
        color: #838383;
        text-align: center;
        padding: 30px;
      ">
    {{
    showEmptyError || "No records available for this filter criteria"
    }}
  </p>
  </div>

  <!-- Table to display the error logs -->
  <div class="asset_list_view_outer" *ngIf="filteredData && filteredData.length > 0">
    <div class="list_view_outer">
      <div class="table-responsive">
        <table class="table table-hover" *ngIf="showEmptyError==''">
          <thead>
            <tr>
              <th>User Name</th>
              <th>Site Name</th>
              <th>Application Name</th>
              <th>Serial Number</th>
              <th>Error</th>
              <th>Error Sent Time</th>
              <th>Last Acknowledged Time</th>
              <th>Last Acknowledged By</th>
              <th></th>
              <!-- Add more headers as needed -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of paginatedReportDataArr">
              <td>{{ item.full_name }}</td>
              <td>{{ item.site_name }}</td>
              <td>{{ item.app_name }}</td>
              <td>{{ item.asset_serial_no }}</td>
              <td>{{ item.error }}</td>
              <td>{{ item.error_locktime | date : "medium" }}</td>
              <td>{{ item.latestAcknowledgedTime || "N/A" }}</td>
              <td>{{ item.latestAcknowledgedBy || "N/A" }}</td>
              <td class="text-right">
                <button class="primary_btn" mat-raised-button (click)="viewErrorLogDetails(item)">
                  View Details
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div
        *ngIf="
          showEmptyError !== '' ||
          (paginatedReportDataArr?.length === 0 && filtersApplied)
        "
        class="no_result"
      >
        <p
          style="
            font-size: 16px;
            color: #838383;
            text-align: center;
            padding: 30px;
          "
        >
          {{
            showEmptyError || ""
          }}
        </p>
      </div>

  <div class="button-container">
    <button mat-raised-button color="primary" (click)="downloadErrorLogs()"
      [disabled]="filteredData.length === 0">
      Print / Save as PDF
    </button>
  </div>

  <!-- Pagination controls, if needed -->
  <div class="d-flex justify-content-center" *ngIf="showEmptyError==''">
    <mat-paginator
    [length]="filteredData?.length"
    [pageSize]="itemsPerPage"
    [pageSizeOptions]="[5, 10, 20]"
    (page)="onPageChange($event)"
    >
    </mat-paginator>
  </div>
</div>
